import {
  formatDateForInput,
  parseCalendarDateFromInput,
} from "@/shared/lib/date-time";
import { DatePicker } from "@/shared/ui/DatePicker";

type PoFormDateFieldProps = {
  label: string;
  value: string;
  onChange: (yyyyMmDd: string) => void;
  placeholder?: string;
  requiredMark?: boolean;
  className?: string;
};

/** PO forms store dates as `yyyy-MM-dd` (API); picker shows `dd/MM/yyyy`. */
export function PoFormDateField({
  label,
  value,
  onChange,
  placeholder = "ເລືອກວັນທີ",
  requiredMark,
  className = "h-9 w-full",
}: PoFormDateFieldProps) {
  return (
    <div className="space-y-2">
      <span className="font-medium text-sm">
        {label}
        {requiredMark ? " *" : null}
      </span>
      <DatePicker
        mode="single"
        value={value.trim() ? parseCalendarDateFromInput(value) : null}
        onChange={(d) => onChange(d ? formatDateForInput(d) : "")}
        placeholder={placeholder}
        className={className}
        captionLayout="dropdown"
        fromYear={2020}
        toYear={2035}
      />
    </div>
  );
}
